import { render } from "./ProductoListadoModal.vue?vue&type=template&id=f6ef9620&scoped=true"
import script from "./ProductoListadoModal.vue?vue&type=script&lang=js"
export * from "./ProductoListadoModal.vue?vue&type=script&lang=js"

import "./ProductoListadoModal.vue?vue&type=style&index=0&id=f6ef9620&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6ef9620"]])

export default __exports__